__turbopack_context__.v({
  "mobileNavColumn": "SecondaryNavbar_Rare-module__1YGija__mobileNavColumn",
  "mobileNavItem": "SecondaryNavbar_Rare-module__1YGija__mobileNavItem",
  "navItem": "SecondaryNavbar_Rare-module__1YGija__navItem",
  "navRow": "SecondaryNavbar_Rare-module__1YGija__navRow",
  "root": "SecondaryNavbar_Rare-module__1YGija__root",
  "secondaryNavRareMobileExpand": "SecondaryNavbar_Rare-module__1YGija__secondaryNavRareMobileExpand",
});
